import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 100%;
`;
